<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <Migalha label="PCEs Disponíveis" v-if="!$verificaPerfilHabilitador()"></Migalha>

    <v-flex>
      <!-- Campos de pesquisa de PCE -->
      <v-card style="padding-bottom: 20px;">
        <v-form ref="formPesquisar" v-model="valid">
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              <v-select
                v-model="pceOrgaos"
                :items="orgaos"
                item-text="sigla"
                item-value="sigla"
                label="Órgão/Unidade"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedDate"
                    label="Data de Abertura"
                    readonly
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  v-model="dataAbertura"
                  no-title
                  scrollable
                  locale="pt-BR"
                  @input="updateDate"
                  @change="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="objeto"
                label="Objeto"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs4 sm2 md2>
              <v-btn large color="info" @click="pesquisarPCEs">Pesquisar</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
      <!-- / Campos de pesquisa de PCE -->
      <v-data-table
        :headers="headers"
        :items="filteredModel"
        :loading="loading"
        :hide-actions="true"
        class="elevation-1"
        :custom-sort="customSort"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.numero }}</td>
          <td class="text-xs-left">{{ props.item.abertura }}</td>
          <td class="text-xs-left">{{ props.item.periodo }}</td>
          <td class="text-xs-left">{{ props.item.orgao }}</td>
          <td class="text-xs-left">{{ props.item.objeto }}</td>
          <td class="text-xs-left">
            <v-icon
              style="-moz-transform: scaleX(-1); -o-transform: scaleX(-1); -webkit-transform: scaleX(-1); transform: scaleX(-1);"
              color="green"
              @click="abrirPce(props.item.link)"
              light
            >reply</v-icon>
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogMensagemTermo" persistent max-width="520px">
        <v-card>
          <v-card-title class="headline">Atenção!</v-card-title>
          <v-card-text>
            <p>Prezado Fornecedor,</p>
            <p>Para prosseguimento da análise, aguardamos o envio do Termo de Declaração de Concordância e Veracidade,
              disponível em: acesso cadastro > solicitações > Termo de Concordância e Veracidade.</p>
            <p class="text-danger">Caso tenha encaminhado o documento informado desconsiderar a informação acima.</p>
          </v-card-text>
          <v-layout row p-b-15 p-t-10>
            <v-flex sm6>
              <v-btn large color="info" @click="dialogMensagemTermo = false;">OK</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-flex>
    <fornecedorrepresentantelegal
      :dados="modelRepresentante"
      :aberto="dialogRepresentante"
      v-if="dialogRepresentante"
      :persistente="true"
    >
    </fornecedorrepresentantelegal>
  </div>
</template>

<script>
import util from "../../plugins/util";
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";
import fornecedorService from "../../services/fornecedorService";
import fornecedorrepresentantelegal from "../fornecedor/components/fornecedorrepresentantelegal";
import uploadDeclaracaoService from "../../services/uploadDeclaracaoService";

export default {
  name: "fornecedor-painel",
  mixins: [util],
  components: {
    Migalha,
    Topo,
    fornecedorrepresentantelegal
  },
  data() {
    return {
      formattedDate: '',
      possuiTermoAceito: false,
      dialogMensagemTermo: false,
      model: [],
      filteredModel: [],
      pceOrgaos: null,
      dataAbertura: null,
      objeto: "",
      orgaos: [],
      loading: false,
      dialogRepresentante: false,
      solicitacaoLista: [],
      modelRepresentante: {},
      valid: true,
      listaUnidadesSolicitacao: [],
      headers: [
        {
          text: this.$t("label.numero"),
          value: "numero",
          align: "left",
          sortable: true,
          width: 100
        },
        {
          text: this.$t("label.abertura"),
          value: "abertura",
          align: "left",
          sortable: true,
          width: 100
        },
        {
          text: this.$t("label.periodo"),
          value: "periodo",
          align: "left",
          sortable: true,
          width: 100
        },
        {
          text: this.$t("label.orgaoUnidade"),
          value: "orgao",
          align: "left",
          sortable: true,
          width: 100
        },
        {
          text: this.$t("label.objeto"),
          value: "objeto",
          align: "left",
          sortable: true,
          width: 100
        },
        {
          text: this.$t("label.acessar"),
          align: "left",
          sortable: false,
          width: 100
        }
      ]
    };
  },
  created() {
    this.$removePreload();
    this.carregarPCE();
    //this.verificaPreenchimentoRepresentante();
    this.verificaPreenchimentoRepresentanteTermo();
  },
  methods: {
    updateDate(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        this.formattedDate = `${day}/${month}/${year}`;
      } else {
        this.formattedDate = '';
      }
    },
    
    pesquisarPCEs() {
      this.$mostrarPreload();

      let dataFormatada = this.dataAbertura
        ? this.formatDateForFilter(this.dataAbertura)
        : null;

      this.filteredModel = this.model.filter(pce => {
        const matchesOrgao = this.pceOrgaos
          ? pce.orgao.includes(this.pceOrgaos)
          : true;
        const matchesDataAbertura = dataFormatada
          ? pce.abertura === dataFormatada
          : true;
        const matchesObjeto = this.objeto
          ? pce.objeto.toLowerCase().includes(this.objeto.toLowerCase())
          : true;
                    
          this.dataAbertura = null;
        
        return matchesOrgao && matchesDataAbertura && matchesObjeto;
      });

      this.$removePreload();
    },
    formatDateForFilter(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      }
      return null;
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === 'abertura') {
          return this.sortAbertura(a, b, isDesc);
        } else if (index === 'periodo') {
          return this.sortPeriodo(a, b, isDesc);
        } else if (index === 'numero') {
          return this.sortNumero(a, b, isDesc);
        } else if (index === 'orgao') {
          return this.sortOrgao(a, b, isDesc);
        } else if (index === 'objeto') {
          return this.sortObjeto(a, b, isDesc);
        } else {
          return 0;
        }
      });
      return items;
    },
    sortAbertura(a, b, isDesc) {
      const dateA = new Date(a.abertura.split('/').reverse().join('-'));
      const dateB = new Date(b.abertura.split('/').reverse().join('-'));
      if (isDesc) {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    },
    sortPeriodo(a, b, isDesc) {
      const periodoA = a.periodo.split(' às ')[0];
      const periodoB = b.periodo.split(' às ')[0];
      if (isDesc) {
        return periodoB.localeCompare(periodoA);
      } else {
        return periodoA.localeCompare(periodoB);
      }
    },
    sortNumero(a, b, isDesc) {
      if (isDesc) {
        return b.numero.localeCompare(a.numero);
      } else {
        return a.numero.localeCompare(b.numero);
      }
    },
    sortOrgao(a, b, isDesc) {
      if (isDesc) {
        return b.orgao.localeCompare(a.orgao);
      } else {
        return a.orgao.localeCompare(b.orgao);
      }
    },
    sortObjeto(a, b, isDesc) {
      if (isDesc) {
        return b.objeto.localeCompare(a.objeto);
      } else {
        return a.objeto.localeCompare(b.objeto);
      }
    },

    carregarPCE() {
      this.$mostrarPreload();
      fornecedorService.listarPCEsFornecedor().then(response => {
        this.model = response.data;
        this.filteredModel = response.data;
        this.orgaos = [...new Set(response.data.map(item => item.orgao))];
        this.$removePreload();
      });
    },
    verificarExibicaoMensagemTermo() {
      const existeSolicitacaoAguardandoAnalise = this.existeSolicitacaoAguardandoAnalise();
      if(existeSolicitacaoAguardandoAnalise && !this.possuiTermoAceito) {
      //  this.dialogMensagemTermo = true;
      }
    },
    existeSolicitacaoAguardandoAnalise(){
      // Aguardando Analise(2)
      const situacoesImpeditivas = [2];
      if(this.solicitacaoLista.length > 0 && this.solicitacaoLista[0].situacaoSolicitacao == 7) return false;
      return this.solicitacaoLista.some(x => situacoesImpeditivas.includes(x.situacaoSolicitacao));
    },

    consultaRepresentante(){
      this.$mostrarPreload();
      if (this.model.tipFornecedor === "F") {
        this.$removePreload();
        return;
      }
      fornecedorService.getRepresentanteLegalFornecedor(this.$store.getters.getUsuarioId).then(
        response =>
        {
          if(response.data != null)
          {
            this.modelRepresentante.representanteLegal = response.data;
            if(this.modelRepresentante.representanteLegal.cpf == null){
              this.dialogRepresentante = true;
            }
          }else{
            this.dialogRepresentante = true;
          }
          this.$removePreload();
        }
      );
    },

    verificaPreenchimentoRepresentanteTermo(){
      this.$mostrarPreload();
      const numCgcFornecedor = this.$store.getters.getUsuarioId;
      uploadDeclaracaoService.possuiTermoAceito(numCgcFornecedor).then( response => {
        this.possuiTermoAceito = response.data;
      });
      if(!this.$verificaPerfilFornecedor()) return;
      fornecedorService.listarSolicitacoes(numCgcFornecedor).then(response => {
        if(response.data == null || response.data.length == 0) return;
        this.solicitacaoLista = response.data;
        this.consultaRepresentante();
        this.verificarExibicaoMensagemTermo();
        this.$removePreload();
      }).catch(() => { this.$removePreload(); });

    },

    // verificaPreenchimentoRepresentante(){
    //   this.$mostrarPreload();
    //   if(!this.$verificaPerfilFornecedor()) return;
    //   const numCgcFornecedor = this.$store.getters.getUsuarioId;
    //   fornecedorService.listarSolicitacoes(numCgcFornecedor).then(response => {
    //     if(response.data == null || response.data.length == 0) return;
    //     this.consultaRepresentante();
    //     this.$removePreload();
    //   }).catch(() => { this.$removePreload(); });
    // },

    abrirPce(endereco){
       //Abrir uma nova aba com o PCE selecionado
       const link = document.createElement('a');
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        if(regex .test(endereco)) {
            link.href = endereco;
            link.setAttribute('download', endereco);
            link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
            return true;
        }
        return false;
    }
  },
  mounted(){
  }
};
</script>
